import styleInject from '../../../../external_node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".popup-body.wcl-vieg60{padding:15px 0;color:#fff;font-size:16px}";
styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=PopupBody.css.js.map
